import { useMutation } from "@apollo/client";
import {
  UpdateBatchDisbursementMutation,
  UpdateBatchDisbursementMutationVariables,
} from "generated/graphql";
import mutations from "Shared/mutations";

export const useUpdateBatchDisbursement = () => {
  const [updateBatchDisbursementMutation] = useMutation<
    UpdateBatchDisbursementMutation,
    UpdateBatchDisbursementMutationVariables
  >(
    mutations.UPDATE_BATCH_DISBURSEMENT,
  );

  const updateBatchDisbursement = async (
    approved: boolean,
    batchDisbursementId: string
  ) => {
    const response = await updateBatchDisbursementMutation({
      variables: {
        approved,
        batchDisbursementId,
      },
    });

    return response;
  };

  return { updateBatchDisbursement };
};
